import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="post-harvest--container-weights"
// Manages per-container output weight entry for the reception step.
// Shows input weight, output weight input, and computed yield per container.
export default class extends Controller {
  static targets = ["containerList", "outputWeight", "yieldDisplay", "totalIn", "totalOut", "containersDataField"]
  static values = { stepType: String }

  connect() {
    this.computeYields()
    this.serialize()
  }

  update() {
    this.computeYields()
    this.serialize()
  }

  computeYields() {
    const rows = this.containerListTarget.querySelectorAll("[data-container-row]")
    let totalIn = 0
    let totalOut = 0

    rows.forEach((row) => {
      const outputInput = row.querySelector("[data-field=output_weight_value]")
      const yieldDisplay = row.querySelector("[data-post-harvest--container-weights-target=yieldDisplay]")
      const currentWeight = parseFloat(outputInput?.dataset?.currentWeight) || 0
      const outputWeight = parseFloat(outputInput?.value) || 0

      totalIn += currentWeight
      totalOut += outputWeight

      if (yieldDisplay) {
        if (currentWeight > 0 && outputWeight > 0) {
          const pct = (outputWeight / currentWeight * 100).toFixed(1)
          yieldDisplay.textContent = `${pct}%`
        } else {
          yieldDisplay.textContent = "—"
        }
      }
    })

    if (this.hasTotalInTarget) {
      const firstRow = rows[0]
      const unit = firstRow?.dataset?.currentWeightUnit || ""
      this.totalInTarget.textContent = `${totalIn.toFixed(2)} ${unit}`.trim()
    }
    if (this.hasTotalOutTarget) {
      const firstRow = rows[0]
      const unit = firstRow?.dataset?.currentWeightUnit || ""
      this.totalOutTarget.textContent = `${totalOut.toFixed(2)} ${unit}`.trim()
    }
  }

  serialize() {
    const rows = this.containerListTarget.querySelectorAll("[data-container-row]")
    const containers = []

    rows.forEach((row) => {
      const containerId = row.dataset.containerId
      const outputWeight = parseFloat(row.querySelector("[data-field=output_weight_value]")?.value) || 0

      const entry = {
        container_id: parseInt(containerId),
        output_weight_value: outputWeight
      }

      if (this.stepHasPhoto()) {
        const photoSignedId = row.querySelector("[data-post-harvest--photo-upload-target='signedId']")?.value || ""
        if (photoSignedId) {
          entry[this.photoSignedIdKey()] = photoSignedId
        }
      }

      containers.push(entry)
    })

    this.containersDataFieldTarget.value = JSON.stringify(containers)
  }

  stepHasPhoto() {
    return this.hasStepTypeValue && this.stepTypeValue === "reception"
  }

  photoSignedIdKey() {
    return "reception_photo_signed_id"
  }
}
